export const KOREAN = 'KOR';
export const ENGLISH = 'ENG';

export type LanguageType = 'KOR' | 'ENG';
